import Vue from "vue";
import Vuex from "vuex";
import Alert from "./modules/Alert";
import apiConference from "@/apis/Conference";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    conference: null
  },
  mutations: {
    SET_CONFERENCE(state, payload) {
      state.conference = payload;
    }
  },
  actions: {
    async setConference({ commit }, code) {
      const params = new URLSearchParams({ code, populate: "tracks" });
      const [data] = await apiConference.get(null, params);

      if (data != null) commit("SET_CONFERENCE", data);
    }
  },
  getters: {
    conferenceId(state) {
      if (state.conference == null) return null;
      return state.conference.id;
    },
    trackName: state => trackId => {
      if (state.conference == null) return null;
      3;
      const trackList = state.conference.tracks;
      return trackList.find(({ id }) => id === trackId).name;
    }
  },
  modules: {
    alert: Alert
  }
});
